const STORAGE_KEY = 'admin:registration:lastSuccessAt'
const REGISTRATION_INTERVAL_MS = 24 * 60 * 60 * 1000

function getStorage() {
  try {
    return window.localStorage || null
  } catch (error) {
    return null
  }
}

function readLastSuccessAt() {
  const storage = getStorage()
  if (!storage) return 0

  try {
    const raw = storage.getItem(STORAGE_KEY)
    if (!raw) return 0
    const value = Number(raw)
    if (!Number.isFinite(value) || value <= 0) return 0
    // Часы пользователя могли уйти вперед и вернуться назад: не даем метке
    // из будущего заблокировать регистрацию дольше суток.
    return Math.min(value, Date.now())
  } catch (error) {
    return 0
  }
}

export function getRegistrationCooldown() {
  const lastSuccessAt = readLastSuccessAt()
  if (!lastSuccessAt) {
    return { blocked: false, remainingMs: 0, availableAt: 0 }
  }

  const availableAt = lastSuccessAt + REGISTRATION_INTERVAL_MS
  const remainingMs = availableAt - Date.now()
  if (remainingMs <= 0) {
    return { blocked: false, remainingMs: 0, availableAt: 0 }
  }

  return { blocked: true, remainingMs, availableAt }
}

export function markRegistrationSuccess() {
  const storage = getStorage()
  if (!storage) return

  try {
    storage.setItem(STORAGE_KEY, String(Date.now()))
  } catch (error) {
    // Приватный режим браузера или переполненное хранилище: ограничение
    // просто не сохранится, регистрация от этого не ломается.
  }
}

export function formatCooldown(remainingMs) {
  const totalMinutes = Math.max(1, Math.ceil(remainingMs / 60000))
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  if (hours && minutes) return `${hours} ч ${minutes} мин`
  if (hours) return `${hours} ч`
  return `${minutes} мин`
}

export { REGISTRATION_INTERVAL_MS }
